"use strict";

(function () {
	function r(e, n, t) {
		function o(i, f) {
			if (!n[i]) {
				if (!e[i]) {
					var c = "function" == typeof require && require;if (!f && c) return c(i, !0);if (u) return u(i, !0);var a = new Error("Cannot find module '" + i + "'");throw a.code = "MODULE_NOT_FOUND", a;
				}var p = n[i] = { exports: {} };e[i][0].call(p.exports, function (r) {
					var n = e[i][1][r];return o(n || r);
				}, p, p.exports, r, e, n, t);
			}return n[i].exports;
		}for (var u = "function" == typeof require && require, i = 0; i < t.length; i++) {
			o(t[i]);
		}return o;
	}return r;
})()({ 1: [function (require, module, exports) {
		'use strict';

		var functions = require('./functions');
		var maps = require('./maps');
		var search = require('./search');

		var pages = {
			documents: require('./pages/documents'),
			email_alerts: require('./pages/email-alerts'),
			disclaimer: require('./pages/disclaimer'),
			search_results: require('./pages/search-results'),
			people: require('./pages/people'),
			insights: require('./pages/insights'),
			history: require('./pages/history'),
			navData: require('./pages/nav-data'),
			products: require('./pages/products')
		};

		var app = {
			init: function init() {
				var pageSelector = 'data-template-name';
				if (navigator.userAgent.indexOf('Mac OS X') != -1) {
					$('body').addClass('mac');
				}
				if (document.querySelector('[' + pageSelector + ']') !== null) {
					var pageName = document.querySelector('[' + pageSelector + ']').getAttribute(pageSelector);
					if (pageName && pages[pageName] && pages[pageName].init) {
						pages[pageName].init();
					}
				}

				if (('ontouchstart' in window || navigator.msMaxTouchPoints > 0) && window.matchMedia('screen and (max-width: 1024px)').matches || 'ontouchstart' in window && navigator.appVersion.indexOf("Mac") != -1) {
					$('html').addClass('touch');
				} else {
					$('html').addClass('no-touch');
				}
				if (!$('.home-banner').next().length) {
					$('.home-banner').addClass('overflow');
				}
				functions.ieInspector();
				functions.iosInspector();
				functions.loadImages();
				functions.headerFunctions();
				functions.checkContent();
				functions.tabs();
				functions.tabular();
				functions.graphlineSlick();
				functions.tabularSlick();
				functions.homeGallerySlick();
				functions.foundersAnimation();
				functions.accordion();
				functions.cleanRteTables();
				functions.removeUnnecessaryTagsFromRTE();
				functions.cookies();
				functions.initSelectric();
				functions.closeDisclaimer();
				functions.peoplePopup();
				functions.backToTop();
				functions.sidebarNavigation();
				functions.slideToThankYouMessage();
				functions.slideToProjectAccordion();
				functions.syncLocations();
				functions.toggleFundsTable();
				functions.strategyHover();
				functions.strategyEqualBtn();
				functions.galleryEqual();
				functions.rteiframeVideo();
				functions.cookieToggle();
				functions.threeCardsClick();
				functions.customPlayBtn();
				if ($('.module-map-container').length) {
					maps.initMap();
				}

				search.initSearch('#header-search', '.header-search-desktop .btn-submit');
				search.initSearch('#sidebar-search', '.sidebar-search .btn-submit');
				search.initSearch('#header-search-mobile', '.header-search-mobile .btn-submit');
			},
			winLoad: function winLoad() {
				$('html').addClass('loaded');
				functions.toggleFundsDropdown();
			},
			winResize: function winResize() {
				if (!$('.nav').is(':visible')) {
					$('.nav').removeAttr('style');
				}
				functions.loadImages();
			},
			winScroll: function winScroll() {
				functions.startAnimation();
				functions.foundersAnimation();
			}
		};

		$(window).on('load', function () {
			if (navigator.userAgent.indexOf('Mac OS X') != -1) {
				$('body').addClass('mac');
			}
			if ($('.home-banner').length && !$('.header--hastop').length) {
				setTimeout(function () {
					$('.home-banner').addClass('home-banner--animation');
				}, 500);
			}
			app.winLoad();
			app.init();
		});

		$(window).on('resize', function () {
			app.winResize();
			functions.graphlineSlick();
			functions.homeGallerySlick();
		});

		$(window).on('scroll', function () {
			app.winScroll();
		});
	}, { "./functions": 2, "./maps": 3, "./pages/disclaimer": 4, "./pages/documents": 5, "./pages/email-alerts": 6, "./pages/history": 7, "./pages/insights": 8, "./pages/nav-data": 9, "./pages/people": 10, "./pages/products": 11, "./pages/search-results": 12, "./search": 13 }], 2: [function (require, module, exports) {
		'use strict';

		module.exports = {
			disableScroll: function disableScroll() {
				if (!this.isScrollDisabled) {
					this.topScroll = $(window).scrollTop();
					$('body').css('top', -this.topScroll + 'px').addClass('scroll-disabled');
					this.isScrollDisabled = true;
				}
			},

			enableScroll: function enableScroll() {
				$('body').removeAttr('style').removeClass('scroll-disabled');
				$(window).scrollTop(this.topScroll);
				this.isScrollDisabled = false;
			},

			ieInspector: function ieInspector() {
				var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
				if (isIE11) {
					$('.parallax--left').addClass('ie-fix');
					$('.hero-banner').addClass('ie-fix');
					$('.js-history').find('.breadcrumbs-line').addClass('ie-fix');
					if ($('.header--home').length) {
						$('html').addClass('ie-fix');
					}
				}
			},

			syncLocations: function syncLocations() {
				var locations = $('.js-office-locations');
				if (locations !== undefined && locations.length) {
					var $locationPins = locations.find('.location__parallax .location__pin');
					var $locationAddress = locations.find('.location__wrap .location__item');

					var $addressIndex = 0;
					$locationAddress.hover(function () {
						$addressIndex = $(this).index();
						$locationPins.each(function () {
							if ($(this).index() == $addressIndex) {
								$(this).addClass('location__pin--active');
							} else {
								$(this).removeClass('location__pin--active');
							}
						});
					});
				}
			},

			iosInspector: function iosInspector() {
				var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
				var mac = navigator.appVersion.indexOf("Mac") != -1;

				if (iOS || mac) {
					$('.parallax--left').addClass('ios-fix');
				}
			},

			loadImages: function loadImages() {
				if (!$('.img-responsive').length) return;
				$('.img-responsive').each(function () {
					var $img = $(this);
					var srcDesktop = $img.data('src-desktop');
					var srcMobile = $img.data('src-mobile');

					if ($img.hasClass('bg-responsive')) {
						if ($(window).width() < 768) {
							$img.css('background-image', 'url(' + srcMobile + ')');
						} else {
							$img.css('background-image', 'url(' + srcDesktop + ')');
						}
					} else {
						if ($(window).width() < 768) {
							$img.attr('src', srcMobile);
						} else {
							$img.attr('src', srcDesktop);
						}
					}
				});
			},

			headerFunctions: function headerFunctions() {
				var header = $('.header');
				var headerScrollClass = 'header-scroll';

				$('.nav li').find('.nav-submenu').closest('li').addClass('has-children');

				if ($('.nav li ul li').find('.nav-submenu').parent().hasClass('has-children') && window.matchMedia('screen and (max-width: 1199px)').matches) {
					$('.nav li ul li').find('.nav-submenu').parent().find('>a').addClass('nav-item-lvl-3');
				}

				$('.js-toggle-header-search').on('click', function () {
					$(this).toggleClass('toggled');
					if ($(this).hasClass('toggled')) {
						$('.header-search-desktop').stop().slideDown(200, function () {
							// $(this).find('input[type="text"]').focus();
							$(this).removeAttr('aria-hidden');
							$(this).find('input').focus();
						});
					} else {
						$('.header-search-desktop').stop().slideUp(200, function () {
							$(this).attr('aria-hidden', 'true');
						});
					}
				});

				$('.js-menu-toggle').off('click').on('click', function () {
					$(this).toggleClass('toggled');
					if ($(this).hasClass('toggled')) {
						if ($('.js-top-btn').hasClass('toggle-top-nav--opened')) {
							$('.js-top-btn').removeClass('toggle-top-nav--opened');
							$('.nav-top').stop().slideUp(200);
						}
						$('.nav').stop().slideDown(400).addClass('opened');
						$('body').addClass('overflow-hidden');
						// $('body').addClass('block-page-scroll');
						// $('html').addClass('block-page-scroll');
					} else {
						$('.js-submenu').slideUp(300);
						$('.nav').find('li.opened').removeClass('opened');
						$('.nav').stop().slideUp(300).removeClass('opened');
						$('body').removeClass('overflow-hidden');
						// $('body').removeClass('block-page-scroll');
						// $('body').removeClass('block-page-scroll');
					}
				});

				$('.js-top-btn').off('click').on('click', function () {
					if ($('.js-menu-toggle').hasClass('toggled')) {
						$('.js-menu-toggle').trigger('click');
					}
					$(this).toggleClass('toggle-top-nav--opened');
					$('.nav-top').stop().slideToggle();
				});

				if ($(window).width() < 1200) {
					$('.nav-main .has-children .toggle-submenu').off('click').on('click', function (e) {
						if ($(this).parent().hasClass('opened')) {
							$(this).parent().removeClass('opened');
							$(this).siblings('.js-submenu').stop().slideUp(300);
						} else {
							$(this).closest('ul').find('.opened').removeClass('opened');
							$(this).closest('ul').find('.js-submenu').stop().slideUp(300);
							$(this).parent().addClass('opened');
							$(this).siblings('.js-submenu').stop().slideDown(300);
						}
					});
				}

				//if less than 1024px or is touch --> when tap on menu item without subitems go to that page
				if (('ontouchstart' in window || navigator.msMaxTouchPoints > 0) && window.matchMedia('screen and (min-width: 1200px)').matches) {
					$('.nav-main li:not(.has-children)').on('touchstart', function (e) {
						if ($(this).children('a').length == 1) {
							window.location = $(this).children('a').attr('href');
						}
					});
				}

				$(window).on('scroll load', function (e) {
					var scrTop = $(window).scrollTop();

					if (scrTop > 0) {
						$(header).addClass(headerScrollClass);
						$('.module-banner').addClass('page-scrolled');
						$('.hero-banner').addClass('page-scrolled');
					} else {
						$(header).removeClass(headerScrollClass);
						$('.module-banner').removeClass('page-scrolled');
						$('.hero-banner').removeClass('page-scrolled');
					}
				});

				var $link = $('.header .nav-main > .has-children');
				var $last = $link.last();
				if ($(window).width() >= 1200 && $(window).width() - $last.offset().left < 300) {
					$last.addClass('nav__last-item');
				}
			},

			tabs: function tabs() {
				$('.tabs').each(function () {
					var $btn = $(this).find('.tab-link');
					var $tab = $(this).find('.tab');
					var $tabToggle = $(this).find('.tab-toggle');
					var activeClass = 'tab-active';

					$btn.on('click', function () {
						var index = $(this).parent().index();
						$btn.removeClass(activeClass);
						$tab.removeClass(activeClass);
						$(this).addClass(activeClass);
						$tab.eq(index).addClass(activeClass);
						$(this).closest('.tabs').removeClass('tabs-toggled');
					});

					$btn.first().addClass(activeClass);
					$tab.first().addClass(activeClass);

					$tabToggle.on('click', function () {
						$(this).closest('.tabs').toggleClass('tabs-toggled');
					});
				});
			},

			foundersAnimation: function foundersAnimation() {
				if (window.matchMedia("(min-width: 767px)").matches && $('.home-founders').length) {
					var founders = $('.home-founders');
					var foundersHeight = $('.home-founders').height();
					var foundersOffsetTop = founders.offset().top;
					if (foundersOffsetTop + foundersHeight - $(window).height() < $(window).scrollTop()) {
						$('.founders__right').addClass('founders__right--active');
					}
				}
			},

			tabular: function tabular() {
				if ($('.tabular').length) {
					var tabItem = $('.tabular li');
					var tabContent = $('.tabular .tabular-content');
					var line = $('.tabular .line-animated');
					var lineHeight = $('.tabular li.active button').offset().top - $('.tabular').offset().top + $('.tabular li.active button').height() / 2 + 'px';

					if ($('.header--hastop').length) {
						line.css('height', lineHeight);
					} else {
						line.animate({
							'height': lineHeight
						}, 1000);
					}

					tabItem.on('click', function () {
						var activeIndex = $(this).index();
						var curretContent = tabContent.eq(activeIndex);
						$(this).addClass('active');
						tabItem.not(this).removeClass('active');
						tabContent.not(curretContent).removeClass('active');
						curretContent.addClass('active');

						if ($(this).hasClass('active')) {
							var item = $(this).find('button');
							var dotPosition = item.offset().top + item.height() / 2;
							var activeItemPosition = item.offset().top - $('.tabular').offset().top;
							line.css({
								'height': activeItemPosition + item.height() / 2 + 'px'
							});
						}
					});
				}
			},

			startAnimation: function startAnimation() {
				if ($('.graphline').length) {
					var graph = $('.graphline');
					var animationPoint = $(window).scrollTop() + $(window).height() * 0.7;
					var graphOffsetTop = graph.offset().top;
					if (animationPoint > graphOffsetTop) {
						graph.addClass('animation-active');
					}
				}
				if ($('.parallax--left').length) {
					var el2 = $('.parallax--left');
					var el2Height = el2.height();
					var el2OffsetTop = el2.offset().top;
					if (el2OffsetTop + el2Height - $(window).height() < $(window).scrollTop()) {
						el2.addClass('animation-active');
					}
				}
			},

			tabularSlick: function tabularSlick() {
				if (window.matchMedia("(max-width: 767px)").matches) {
					$('.tabular-part-right, .location__wrap').not('.slick-initialized').slick({
						arrows: false,
						slidesToShow: 1,
						dots: true,
						swipeToSlide: true
					});
					$('.awards__wrap').not('.slick-initialized').slick({
						arrows: false,
						slidesToShow: 1,
						dots: false,
						swipeToSlide: true
					});
					$('.strategy__wrap').not('.slick-initialized').slick({
						arrows: true,
						slidesToShow: 1,
						dots: true,
						swipeToSlide: true
					});
				}
				if (window.matchMedia("(max-width: 767px)").matches && $('.insights-main').length) {
					$('.insights__circlesContainer').not('.slick-initialized').slick({
						arrows: true,
						slidesToShow: 1,
						dots: true,
						swipeToSlide: true,
						speed: 500
					});
				}
			},

			graphlineSlick: function graphlineSlick() {
				if (window.matchMedia("(max-width: 767px)").matches && $('.graph-partials').length) {
					$('.graph-partials').not('.slick-initialized').slick({
						centerMode: true,
						arrows: false,
						slidesToShow: 1,
						dots: true,
						swipeToSlide: true,
						responsive: [{
							breakpoint: 768,
							settings: {
								centerPadding: '165px'
							}
						}, {
							breakpoint: 665,
							settings: {
								centerPadding: '140px'
							}
						}, {
							breakpoint: 580,
							settings: {
								centerPadding: '120px'
							}
						}, {
							breakpoint: 480,
							settings: {
								centerPadding: '90px'
							}
						}, {
							breakpoint: 380,
							settings: {
								centerPadding: '70px'
							}
						}]
					});
				}
			},

			homeGallerySlick: function homeGallerySlick() {
				if (window.matchMedia("(max-width: 1024px)").matches && $('.home-gallery-wrap').length) {
					$('.home-gallery-wrap').not('.slick-initialized').slick({
						infinite: true,
						centerMode: true,
						centerPadding: '0',
						slidesToShow: 3,
						arrows: false,
						focusOnSelect: true,
						speed: 500,
						responsive: [{
							breakpoint: 768,
							settings: {
								centerMode: true,
								centerPadding: '30px',
								slidesToShow: 1,
								arrows: false,
								dots: true,
								swipeToSlide: true
							}
						}]
					});
				}

				if (window.matchMedia("(min-width: 1025px)").matches && $('.home-gallery-wrap').length) {
					var alwaysActiveElement = $('.home-gallery-item:nth-child(2)');
					alwaysActiveElement.addClass('active'); // activate secon item on page load

					$('.home-gallery-item').mouseover(function () {
						$('.home-gallery-item').removeClass('active');
						if ($(this).index() === 1) {
							// second item - always active
							alwaysActiveElement.addClass('active');
						} else {
							// remove active if other items hovered
							alwaysActiveElement.removeClass('active');
						}
					});
					$('.home-gallery-item').mouseleave(function () {
						$('.home-gallery-item').removeClass('active');
						$(this).addClass('active'); // make sure second item is still active on mouseleave
					});
				}
			},

			parallax: function parallax() {
				if ($('.parallax').length && matchMedia("(min-width: 1025px)").matches && $('.parallax').closest('.login-page').length == 0 && !navigator.userAgent.match(/Trident\/7\./)) {
					var parallaxElements = $('.parallax'),
					    parallaxQuantity = parallaxElements.length,
					    parallaxSpeed = 5;
					//need to move parallax svg with parallax background position
					var parallaxSvg = $('.parallax svg');
					var parallaxWithSvg = $('.parallax--left');

					$(window).on('scroll', function () {
						window.requestAnimationFrame(function () {

							for (var i = 0; i < parallaxQuantity; i++) {
								var currentElement = parallaxElements.eq(i);
								var speed = parallaxSpeed;
								var parallaxInScreenOffsetTop = currentElement.offset().top - $(window).height();

								if (parallaxInScreenOffsetTop < $(window).scrollTop()) {
									//start parallax effect only when animated dots comes into viewport
									if (currentElement.data('parallax-speed')) {
										speed = parseInt(currentElement.data('parallax-speed'));
									}

									//move parallax by changing it's background position on scroll
									var scrolled = $(window).scrollTop() - parallaxInScreenOffsetTop;
									var positionY = -(scrolled / speed);
									var parallaxPosition = '0' + positionY * 2 + '%';
									currentElement.css({
										backgroundPosition: parallaxPosition
									});

									//move parallax svg with parallax background position
									if (currentElement.is(parallaxWithSvg)) {
										// var parallaxSvgPosition = (83 + (positionY / 2)) + 'px';
										var parallaxSvgPosition = 43 + positionY / 2 + 'px';
										parallaxSvg.css({
											'top': parallaxSvgPosition
										});
									}
								}
							}
						});
					});
				}
			},

			accordion: function accordion() {
				var pageLoad = true;
				$('.accordion').each(function () {
					$(this).find('.accordion-button').on('click', function () {
						var $btn = $(this);
						if ($btn.hasClass('opened')) {
							$btn.removeClass('opened');
							$btn.next('.accordion-content').stop().slideUp('fast', function () {
								$(this).attr('aria-hidden', 'true');
								if (!pageLoad && $('.header-scroll').length) {
									$('html, body').animate({
										scrollTop: $btn.offset().top - $('.header-scroll').height() - 20
									}, 400);
								} else if (!pageLoad) {
									$('html, body').animate({
										scrollTop: $btn.offset().top - 20
									}, 400);
								}
							});
						} else {
							$btn.parent().siblings().find('.accordion-button.opened').removeClass('opened');
							$btn.parent().siblings().find('.accordion-content').stop().slideUp('fast', function () {
								$(this).attr('aria-hidden', 'true');
							});
							$btn.addClass('opened');
							$btn.next('.accordion-content').stop().slideDown('fast', function () {
								$(this).removeAttr('aria-hidden');
								if (!pageLoad && $('.header-scroll').length) {
									$('html, body').animate({
										scrollTop: $btn.offset().top - $('.header-scroll').height() - 20
									}, 400);
								} else if (!pageLoad) {
									$('html, body').animate({
										scrollTop: $btn.offset().top - 20
									}, 400);
								}
							});
						}
					});
				});
			},

			cleanRteTables: function cleanRteTables() {
				var table = $('.rte-content table');
				var rteTable = table.wrap('<div class="table"/>');
				rteTable.removeAttr('style');
				rteTable.removeAttr('border');
				table.find('td, th').removeAttr('style');
			},

			removeUnnecessaryTagsFromRTE: function removeUnnecessaryTagsFromRTE() {
				$('ul.bullets').each(function () {
					var tempText = $(this).find('ul').children();
					$(this).find('ul').remove();
					$(this).append(tempText);
				});
			},

			cookies: function cookies() {
				var self = this;
				var $cookies = $('.cookies');
				if ($cookies.length) {
					$('.footer').css('margin-bottom', $cookies.outerHeight());
					$('.js-close-cookies').on('click', function () {
						$cookies.stop().slideUp(300, function () {
							$cookies.remove();
							self.createCookie('cookieAccepted', 'yes', 365);
							// self.stickyFooter();
						});
						$('.footer').removeAttr('style');
					});
					$(window).resize(function () {
						$('.footer').css('margin-bottom', $('.cookies').outerHeight());
					});
				}
			},

			initSelectric: function initSelectric() {
				var $select = $('select');
				if ($select !== undefined && $select.length) {
					$select.selectric({
						disableOnMobile: false,
						nativeOnMobile: false,
						arrowButtonMarkup: '<span class="arrow"></span>'
					});
				}
			},

			closeDisclaimer: function closeDisclaimer() {
				var self = this;
				if ($('.disclaimer-overlay').length) {
					$('.js-close-disclaimer').on('click', function () {
						$(this).closest('.disclaimer-overlay').hide();
						self.createCookie("termsAndConditionsClosed", "1", 365);
					});
				}
			},

			peoplePopup: function peoplePopup() {
				var _this = this;
				if ($('.team-member').length) {
					$('.team-member').find('a').on('click', function (e) {
						e.preventDefault();
						var $member = $(this).closest('.team-member');
						var memberDetails = $member.find('.team-member-details').html();
						var $popup = $('.people-popup-overlay');
						$popup.find('.popup-content').html(memberDetails);
						$popup.stop().fadeIn(500).addClass('popup-opened').removeAttr('aria-hidden');
						if ($(window).width() < 768) {
							var popupContentHeight = $popup.find('.popup-content').height();
							var popupImageHeight = $popup.find('.team-member-image').outerHeight(true);
							var popupInfoHeight = $popup.find('.team-member-info').height();

							if (popupImageHeight + popupInfoHeight > popupContentHeight) {
								$popup.find('.scroll-arrow').fadeIn();
							}
							$popup.find('.popup-content').on('scroll', function () {
								var scr = $(this).scrollTop();
								if (scr + popupContentHeight >= popupImageHeight + popupInfoHeight) {
									$popup.find('.scroll-arrow').fadeOut();
								} else {
									$popup.find('.scroll-arrow').fadeIn();
								}
							});
						}
						_this.disableScroll();
					});

					// Close popup on click on X, overlay and Escape key
					$(document).on('click', '.people-popup .js-close-popup', function () {
						$('.people-popup-overlay').stop().fadeOut(500, function () {
							$('.people-popup-overlay').find('.popup-content').html('');
						}).removeClass('popup-opened').attr('aria-hidden', 'true');
						_this.enableScroll();
					});

					$(document).on('click', '.people-popup-overlay', function (e) {
						if (e.target !== this) return;
						$('.people-popup-overlay').stop().fadeOut(500, function () {
							$('.people-popup-overlay').find('.popup-content').html('');
						}).removeClass('popup-opened').attr('aria-hidden', 'true');
						_this.enableScroll();
					});

					$(document).off('keydown').on('keydown', function (e) {
						if (e.which === 27) {
							$('.people-popup-overlay').stop().fadeOut(500, function () {
								$('.people-popup-overlay').find('.popup-content').html('');
							}).removeClass('popup-opened').attr('aria-hidden', 'true');
							_this.enableScroll();
						}
					});
					var personId = document.location.hash;

					if (personId) {
						$('.expandable-item-visible[data-popup="#item' + personId.replace('#', '') + '"]').find('a').click();
					}
				}
			},

			backToTop: function backToTop() {
				$('.btn-to-top').on('click', function () {
					$('html, body').animate({
						scrollTop: 0
					}, 600);
				});
			},

			createCookie: function createCookie(name, value, days) {
				var expires = '';
				if (days) {
					var date = new Date();
					date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
					expires = "; expires=" + date.toUTCString();
				}
				document.cookie = name + "=" + value + expires + "; path=/";
			},

			// equal heights
			equalHeights: function equalHeights(arrayItems, count) {
				if (arrayItems !== undefined && arrayItems.length > 0) {
					arrayItems.height('');

					var maxH = 0;

					if (count) {
						var arrays = [];
						while (arrayItems.length > 0) {
							arrays.push(arrayItems.splice(0, count));
						}

						for (var i = 0; i < arrays.length; i += 1) {
							var data = arrays[i];
							maxH = 0;
							for (var j = 0; j < data.length; j += 1) {
								var currentH = $(data[j]).outerHeight(true);
								if (currentH > maxH) {
									maxH = currentH;
								}
							}

							for (var k = 0; k < data.length; k += 1) {
								$(data[k]).css('height', maxH);
							}
						}
					} else {
						arrayItems.each(function () {
							var currentH2 = $(this).outerHeight(true);
							if (currentH2 > maxH) {
								maxH = currentH2;
							}
						});

						arrayItems.css('height', maxH);
					}
				}
			},

			sidebarNavigation: function sidebarNavigation() {
				$('.sidebar-links').find('.active').parents('li').removeClass('active');
				$('.sidebar-links').find('.active').parents('li').addClass('sublevel-active');

				var active = $('.sidebar-links').find('a[href="' + window.location.pathname + '"]');
				for (var index = 0; index <= active.parents().length; index++) {
					var element = $(active.parents()[index]);

					if (element.hasClass('level-first')) {
						break;
					}

					if (element.is('li')) {
						// li parent
						if (index == 0) {
							// first li parent
							element.addClass('active');
						}

						if (element.find('ul.sidebar-level').length) {
							// child submenu
							var submenu = $(element.find('ul.sidebar-level')[0]);
							submenu.show();
						}

						continue;
					}

					if (element.is('ul.sidebar-level')) {
						// ul parent
						if (index == 1) {
							// first ul parent
							element.addClass('is-active');
						} else {
							// other ul parents
							element.addClass('was-active');
						}
					}
				}
			},

			slideToThankYouMessage: function slideToThankYouMessage() {
				if ($('.contourMessageOnSubmit').length) {
					$('html, body').animate({
						scrollTop: $('.contourMessageOnSubmit').offset().top
					}, 600);
				}
			},

			slideToProjectAccordion: function slideToProjectAccordion() {
				$(document).on('click', '.popup-link', function () {
					var $pinId = $(this).data('id');
					var $accordionId = $('.accordion-row[id=' + $pinId + ']');

					$('html, body').animate({
						scrollTop: $accordionId.offset().top
					}, 600);
					$accordionId.find('.accordion-button').click();
				});
			},

			toggleFundsTable: function toggleFundsTable() {
				if ($('.funds-section').length) {
					$('.js-toggle-table').on('click', function () {
						$(this).next('ul').slideToggle(800);
						//	$('.funds__btn-wrap').find('ul').slideToggle(800);
						$(this).toggleClass('funds__btn--active');
					});
				}
			},

			toggleFundsDropdown: function toggleFundsDropdown() {
				if ($('.funds-section').length) {
					$('.js-toggle-dropdown').each(function () {
						var $btn = $(this);
						var btnWidth = $btn.parent().width();
						setTimeout(function () {
							$btn.css('width', btnWidth + 'px');
							$btn.next('ul').addClass('dropdown-loaded');
						}, 50);
					});
					$('.js-toggle-dropdown').off('click').on('click', function () {
						var $this = $(this);
						var $dropdown = $this.next('ul');
						if (!$this.hasClass('funds__btn--active')) {
							$dropdown.stop().slideDown(500);
							$this.addClass('funds__btn--active');
						} else {
							$dropdown.stop().slideUp(400);
							$this.removeClass('funds__btn--active');
						}
					});
				}
			},

			strategyHover: function strategyHover() {
				if ($('.home-strategy').length && window.matchMedia("(min-width: 1025px)").matches) {
					var readMore = $('.home-strategy').find('.strategy__item .btn');
					var strategyLinks = $('.home-strategy').find('.strategy__item .strategy__link');
					readMore.hover(function () {
						strategyLinks.not($(this).closest('.strategy__item').find('.strategy__link').addClass('strategy__link--active')).removeClass('strategy__link--active');
					});

					readMore.mouseleave(function () {
						$(this).closest('.strategy__item').find('.strategy__link').removeClass('strategy__link--active');
					});

					strategyLinks.hover(function () {
						readMore.not($(this).closest('.strategy__item').find('.btn').addClass('strategy__btn--active')).removeClass('strategy__btn--active');
					});

					strategyLinks.mouseleave(function () {
						$(this).closest('.strategy__item').find('.btn').removeClass('strategy__btn--active');
					});
				}
			},

			strategyEqualBtn: function strategyEqualBtn() {
				if ($('.home-strategy').length) {
					var strategyLinks = $('.home-strategy').find('.strategy__item .strategy__link');
					var maxHeight = 0;
					var btnHeight = 0;

					for (var i = 0; i < strategyLinks.length; i++) {
						btnHeight = $(strategyLinks).eq(i).height();
						if (btnHeight < maxHeight) {
							i++;
						} else {
							maxHeight = btnHeight;
							i++;
						}
					}

					strategyLinks.each(function () {
						$(this).height(maxHeight);
						$(this).find('.title').height(maxHeight);
					});
				}
			},

			galleryEqual: function galleryEqual() {
				if ($('.home-gallery').length) {
					var galleryFigs = $('.home-gallery').find('.home-gallery-item figcaption');
					var maxHeight = 0;
					var figHeight = 0;

					for (var i = 0; i < galleryFigs.length; i++) {
						figHeight = $(galleryFigs).eq(i).outerHeight();
						if (figHeight < maxHeight) {
							i++;
						} else {
							maxHeight = figHeight;
							i++;
						}
					}

					galleryFigs.each(function () {
						$(this).height(maxHeight);
					});
				}
			},

			rteiframeVideo: function rteiframeVideo() {
				$('.rte-content').find('iframe').each(function () {
					if ($(this).attr('src').indexOf('youtube.com') !== -1 || $(this).attr('src').indexOf('vimeo.com') !== -1) {
						$(this).wrap('<span class="rte-iframe"/>');
					}
				});
			},

			cookieToggle: function cookieToggle() {
				$('.js-cookie-btn').on('click', function (e) {
					e.preventDefault();
					$('#ccc-icon').trigger('click');
				});
				$(document).on('click', '#ccc-overlay', function () {
					$('#ccc-dismiss-button').trigger('click');
				});
			},

			checkContent: function checkContent() {
				var contactPage = $('.js-contact-page');
				if (!contactPage.length) return;
				var firstItem = contactPage.find('.standard-content').children().eq(0);
				if ($(firstItem).hasClass('content-box')) return;
				contactPage.find('.content-box').eq(0).addClass('content-box--top');
			},

			threeCardsClick: function threeCardsClick() {
				var toggleClass = 'three-cards__card--expand';
				var $buttons = $('.js-three-card-toggle');
				$buttons.each(function (_, button) {
					var $this = $(button);
					var $card = $this.closest('.js-three-card');
					$this.on('click', function () {
						if ($card.hasClass(toggleClass)) {
							$card.removeClass(toggleClass);
						} else {
							$card.addClass(toggleClass);
						}
					});
				});
			},

			customPlayBtn: function customPlayBtn() {
				$('.js-custom-play').on('click', function (e) {
					var $this = $(e.currentTarget);
					var $parent = $this.parent();
					var $iframe = $parent.find('iframe');
					var src = $iframe.data('src') + '&muted=1&autoplay=1';
					$iframe.attr('src', src);
					$parent.addClass('media-module__card-image-holder--show');
				});
			}
		};
	}, {}], 3: [function (require, module, exports) {
		'use strict';

		module.exports = {

			map: '',
			// array of categories taken from checkboxes name attribute
			categories: [],
			// array of projects with color, category, latitude and longitude
			projects: [],
			// array of projects that should be shown depending on checkbox selection
			showProjects: [],
			// array of markers to be displayed on the map, also depending on checkbox selection
			markers: [],

			infoWindow: '',

			bindCheckboxEvents: function bindCheckboxEvents() {
				var that = this;
				// clicking on checkboxes will check which categories are selected and it will render the map with new markers
				$('.project-filters input[type="checkbox"]').on('change', function (e) {
					that.getAllCategories();
					that.renderProjects();
					that.renderProjectItems();
				});
			},

			getAllCategories: function getAllCategories() {
				var that = this;
				// pulling the checked categories on page load and checkboxes selection
				$('.project-filters input[type="checkbox"]').each(function () {
					var catName = $(this).attr('name');
					// on checkbox change, if this category exists in the "categories" array, it is being removed from the array
					if (that.categories.indexOf(catName) !== -1) {
						that.categories.splice(that.categories.indexOf(catName), 1);
					}
					// on checkbox change, if the checkbox is checked, this category is added to the "categories" array
					if ($(this).is(':checked')) {
						that.categories.push(catName);
					}
				});
			},

			getProjectsData: function getProjectsData() {
				var that = this;
				// collecting all the data from printed projects
				$('.project-filter-items').find('.accordion-row').each(function () {
					var color = $(this).data('project-color'),
					    category = $(this).data('project-category'),
					    latitude = $(this).data('project-latitude'),
					    longitude = $(this).data('project-longitude'),
					    popupText = $(this).find('.project-popup').html();

					// and adding the data into "projects" array
					that.projects.push({
						color: color,
						category: category,
						latitude: latitude,
						longitude: longitude,
						popupText: popupText
					});
				});
			},

			renderMap: function renderMap() {
				var latitude = 55.864237,
				    longitude = -4.251806,
				    zoomLvl = 8;

				if ($(window).width() < 768) {
					zoomLvl = 7;
				}

				// rendering the google map with already set position and zoom level
				var mapOptions = {
					center: new google.maps.LatLng(latitude, longitude),
					zoom: zoomLvl,
					draggable: true,
					disableDefaultUI: true,
					mapTypeId: google.maps.MapTypeId.ROADMAP,
					mapTypeControlOptions: {
						style: google.maps.ZoomControlStyle.SMALL,
						position: google.maps.ControlPosition.TOP_RIGHT
					},
					styles: this.mapStyles
				};

				this.map = new google.maps.Map($('.module-map-container')[0], mapOptions);
			},

			renderProjects: function renderProjects() {
				var that = this;
				// clearing the projects that should be shown, and then filling them up if the requirements are met
				that.showProjects = [];
				var extension = 'svg';

				var isIE = /*@cc_on!@*/false || !!document.documentMode;
				isIE ? extension = 'png' : extension = 'svg';

				// first we have to destroy every marker on the map, otherwise they would always be visible
				for (var j = 0; j < that.markers.length; j++) {
					that.markers[j].setVisible(false);
				}

				// go through every project and create a marker for it with required color, latitude and longitude

				var _loop = function _loop(i) {
					var project = that.projects[i];
					var marker = '';
					var icon = '';

					if ($(window).width() < 768) {
						icon = new google.maps.MarkerImage('/images/pins/map-pin-' + project.color + '-mobile.' + extension, new google.maps.Size(23, 34), new google.maps.Point(0, 0), new google.maps.Point(11, 34));
					} else {
						icon = new google.maps.MarkerImage('/images/pins/map-pin-' + project.color + '.' + extension, new google.maps.Size(37, 56), new google.maps.Point(0, 0), new google.maps.Point(18, 56));
					}

					marker = new google.maps.Marker({
						position: new google.maps.LatLng(project.latitude, project.longitude),
						draggable: false,
						animation: google.maps.Animation.DROP,
						icon: icon,
						map: that.map
					});

					that.infoWindow = new google.maps.InfoWindow({
						maxWidth: 210
					});
					google.maps.event.addListener(marker, 'click', function () {
						var content = project.popupText;
						that.infoWindow.setContent(content);
						that.infoWindow.open(that.map, this);
					});

					// if categories to be visible contain this particular project, we push the project into the array, and it's relative marker to the markers array
					if (that.categories.indexOf(project.category) !== -1) {
						that.showProjects.push(project);
						that.markers.push(marker);
						marker.setVisible(true);
					} else {
						// hiding the markers if they don't belong to the categories array
						marker.setVisible(false);
					}
				};

				for (var i = 0; i < that.projects.length; i++) {
					_loop(i);
				}
			},

			renderProjectItems: function renderProjectItems() {
				var that = this;
				// check every project item if it should be visible
				$('.project-filter-items').find('.accordion-row').each(function () {
					var $this = $(this);
					var catName = $this.data('project-category');
					if (that.categories.indexOf(catName) !== -1) {
						$this.slideDown(300);
					} else {
						$this.find('.accordion-button').removeClass('opened');
						$this.find('.accordion-content').slideUp(200);
						$this.slideUp(200);
					}
				});
			},

			initMap: function initMap() {
				this.getAllCategories();
				this.getProjectsData();
				this.bindCheckboxEvents();
				this.renderMap();
				this.renderProjects();
				this.renderProjectItems();
			},

			mapStyles: [{
				"featureType": "administrative",
				"elementType": "labels",
				"stylers": [{
					"visibility": "simplified"
				}]
			}, {
				"featureType": "landscape",
				"elementType": "geometry",
				"stylers": [{
					"saturation": "0"
				}, {
					"lightness": "100"
				}, {
					"gamma": "2.31"
				}, {
					"visibility": "on"
				}]
			}, {
				"featureType": "poi.park",
				"elementType": "geometry",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "poi.park",
				"elementType": "labels",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road",
				"elementType": "geometry",
				"stylers": [{
					"saturation": "-100"
				}, {
					"color": "#f5f5f5"
				}]
			}, {
				"featureType": "road",
				"elementType": "labels.text",
				"stylers": [{
					"visibility": "simplified"
				}, {
					"color": "#666666"
				}]
			}, {
				"featureType": "road",
				"elementType": "labels.icon",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road.highway",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "road.arterial",
				"elementType": "geometry.stroke",
				"stylers": [{
					"visibility": "off"
				}]
			}, {
				"featureType": "water",
				"elementType": "geometry.fill",
				"stylers": [{
					"lightness": "50"
				}, {
					"gamma": ".75"
				}, {
					"saturation": "100"
				}]
			}]
		};
	}, {}], 4: [function (require, module, exports) {
		'use strict';

		var disclaimer = {
			init: function init() {
				var self = this;
				self.disclaimer();
			},

			disclaimer: function disclaimer() {
				$("#js-agree").click(function () {
					$(this).attr("href", "/Umbraco/Surface/DisclaimerSurface/Accept");
				});
				$("#js-disagree").click(function () {
					var test = $(this).data('redirect-url');
					$(this).attr("href", test);
				});
			}
		};

		module.exports = disclaimer;
	}, {}], 5: [function (require, module, exports) {
		'use strict';

		var documents = {
			init: function init() {
				window.location.hash = 'currentPage=1';
				getItems();

				function getItems(year, archive) {
					var $year = year ? year : $('button.tab-link').eq(0).data('year');
					var $archive = archive ? archive : 'false';
					var $container = $('.download-list');
					var $currentPage = window.location.hash.split("=")[1];

					$.get('/umbraco/surface/listing/DocumentsListing', { currentPage: $currentPage, year: $year, isArchive: $archive, pagination: true }, function (response) {
						$container.children().remove();
						$container.append(response);
						var $selectedYear = $('.tab-link').closest('.tab-active').data('year');
						var isArchive = $('.tab-link').closest('.tab-active').attr('archive') !== undefined;

						$('.pagination-item').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).text();
							getItems($selectedYear, isArchive);
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});

						$('.arrow-prev').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).data('page');
							getItems($selectedYear, isArchive);
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});

						$('.arrow-next').on('click', function () {
							window.location.hash = 'currentPage=' + $(this).data('page');
							getItems($selectedYear, isArchive);
							$('html, body').animate({ scrollTop: $('.tabs').offset().top }, 600);
						});

						$('.download-tab').addClass('tab-active');
					});
				}

				$('.tab-link').on('click', function () {
					window.location.hash = 'currentPage=1';
					var $year = $(this).data('year');
					var $archive = $(this).attr('archive') !== undefined;
					getItems($year, $archive);
				});
			}
		};

		module.exports = documents;
	}, {}], 6: [function (require, module, exports) {
		'use strict';

		var email_alerts = {
			init: function init() {

				if ($('.error').length) {
					setTimeout(function () {
						$('html, body').animate({ scrollTop: $('.error').first().closest('.row').offset().top }, 600);
					}, 300);
				}

				if ($('.success-message').length) {
					$('html, body').animate({ scrollTop: $('.success-message').offset().top }, 600);
				}
				if ($('.error-message').length) {
					$('html, body').animate({ scrollTop: $('.error-message').offset().top }, 600);
				}

				if ($('#ChoosenAlerts').val() != '') {
					var choosenAlerts = $('#ChoosenAlerts').val().split(',');
					for (var i = 0; i < choosenAlerts.length; i++) {
						var checkBoxName = choosenAlerts[i].split(' ')[0];
						$('label[for="' + checkBoxName + '"]').prev().attr('checked', true);
					}
				}

				$("#js-email-alerts-submit").on('click', function (e) {
					//e.preventDefault();
					var errorCounter = 0;
					$('.required-field').each(function () {
						if ($(this).val() == '') {
							errorCounter = errorCounter + 1;
						}
					});
					if (errorCounter === 0) {
						e.preventDefault();
						if (grecaptcha.getResponse() !== "") {
							grecaptcha.reset();
						}
						grecaptcha.execute();
					}
				});

				$('.selectric-items li').on('click', function () {
					var $this = $(this);
					var selectedValue = $this.data('index') === 0 ? '' : $this.text();

					$('#Category').val(selectedValue);
				});

				$("input:checkbox").on('change', function () {
					var value = "";
					var $selectedItems = $("input:checkbox:checked").next();
					for (var _i = 0; _i < $selectedItems.length; _i++) {
						var $item = $selectedItems[_i];
						var isLast = _i === $selectedItems.length - 1;
						value += $item.innerText + (isLast ? "" : ",");
					}

					$("#ChoosenAlerts").val(value);
				});
			}
		};

		module.exports = email_alerts;
	}, {}], 7: [function (require, module, exports) {
		'use strict';

		var history = {
			init: function init() {
				this.syncYears();
			},
			syncYears: function syncYears() {
				var historyTimeline = $('.js-history');
				if (historyTimeline !== undefined && historyTimeline.length) {
					var $openNav = $('.js-link-years');
					var $years = $openNav.find('li button');
					var $yearsMob = $openNav.find('li');
					var $navBtn = $('.js-nav-btn');
					var $historyContents = historyTimeline.find('.history__content');
					var $historyContentFirst = $historyContents.first();
					var $historyDate = $('.js-history-date');
					var $dateOrange = historyTimeline.find('.history__date--orange');
					var $lineContent = $('.history__lineContent');

					var $windowDistance = $(window).scrollTop();
					var $offsetForOrange = $historyContentFirst.offset().top - $('.history__section').offset().top + 15;
					var $offsetForDashed = $offsetForOrange + $dateOrange.height();
					var $offsetForLine = $offsetForOrange - 12;
					var $headerHeight = $('.header').height();
					var $navDistance = $('.main-content').offset().top - $headerHeight;
					var $dateText = '';
					var $dateOffset = 0;
					var $z = 0;
					var $yearsText = $years.map(function () {
						return $(this).text();
					});
					var dateCheck = function dateCheck(navDates, infoDate, activeDate) {
						navDates.each(function () {
							var $orangeText = infoDate.text();
							if ($(this).text() == $orangeText && window.matchMedia('screen and (min-width: 768px)').matches) {
								$(this).addClass(activeDate);
							} else {
								$(this).removeClass(activeDate);
							}
						});
					};

					//height for solid line
					$('.breadcrumbs-line--wrap').css({
						'height': $offsetForLine + 'px'
					});

					//height for dashed line
					$lineContent.find('.history__dashed').css({
						'top': $offsetForDashed + 'px'
					});

					//animation for orange date
					$dateOrange.animate({
						'top': $offsetForOrange + 'px',
						opacity: '1'
					}, 1000);

					//dropdown list for mobile
					$dateOrange.text($yearsText.get(0));
					$navBtn.text($yearsText.get(0));

					//adding active class to navigation items
					dateCheck($years, $dateOrange, 'year--active');

					//change fixed navigation on scroll
					var changeDotNav = function changeDotNav() {
						if ($(window).scrollTop() != 0) {
							$headerHeight = $('.header-scroll').height();
						} else {
							$headerHeight = $('.header').height();
						}
						if ($windowDistance >= $navDistance) {
							$('.history__line--active').css({
								'top': $headerHeight
							});
							$('.breadcrumbs-line').css({
								'top': $headerHeight
							});
							if (window.matchMedia('screen and (min-width: 768px)').matches && !$openNav.hasClass('.history__line--active')) {
								$openNav.addClass('history__years--active');
							}
							$lineContent.addClass('history__line--active');
						} else {
							$('.history__lineContent').css({
								'top': '0'
							});
							$('.breadcrumbs-line').css({
								'top': 0
							});
							$openNav.removeClass('history__years--active');
							$lineContent.removeClass('history__line--active');
						}
					};

					changeDotNav();

					var checkOffset = function checkOffset() {
						if (window.matchMedia('screen and (min-width: 767px)').matches) {
							if ($openNav.offset().top + $openNav.height() >= $('.footer').offset().top + ($headerHeight + 100)) {
								$openNav.addClass('history__years--float');
							}
							if ($(document).scrollTop() + window.innerHeight < $('.footer').offset().top) {
								$openNav.removeClass('history__years--float');
							}
						}
					};

					//changing presentation date and nav date on scroll
					$(window).on('scroll', function () {
						$windowDistance = $(this).scrollTop();
						var documentH = $(document).height();
						var windowH = $(window).height();
						var $lastOffset = $historyDate.last().offset().top - $(window).scrollTop() - $historyDate.last().height();

						changeDotNav();
						checkOffset();
						history.calculateAsideHeight($openNav);

						$historyDate.each(function () {
							$dateOffset = $(this).offset().top - $(window).scrollTop() - $(this).height();

							dateCheck($years, $dateOrange, 'year--active');

							if ($dateOffset <= $offsetForDashed) {
								$historyDate.not($(this).hide()).show();
								$dateText = $(this).text();
								$dateOrange.text($dateText);
								if ($windowDistance + windowH == documentH) {
									$years.removeClass('year--active');
									$('.js-link-years li').last().find('button').addClass('year--active');
									$historyDate.hide();
									$dateOrange.text($historyDate.last().text());
								}
								if ($lastOffset <= $offsetForDashed) {
									$years.removeClass('year--active');
									$('.js-link-years li').last().find('button').addClass('year--active');
								}
							}
						});
					});

					$navBtn.click(function () {
						$(this).toggleClass('history__years-btn--active');
						$(this).next().toggleClass('history__years--open');
					});

					$yearsMob.click(function () {
						var $listText = $(this).find('button').text();
						var $scrollDest = '';
						var numberDest = 0;
						changeDotNav();

						if ($historyContents.length > 0) {
							$historyContents.each(function () {
								$scrollDest = $(this).offset().top - $offsetForOrange - $headerHeight;
								if ($listText == $(this).data('year') && numberDest < 1) {
									numberDest++;
									$('html, body').animate({
										scrollTop: $scrollDest
									}, 1000);
								}
							});
							if (window.matchMedia('screen and (max-width: 767px)').matches) {
								$openNav.removeClass('history__years--open');
							}
						}
					});
				}
			},
			calculateAsideHeight: async function calculateAsideHeight(openNav) {
				if (window.innerWidth < 844) return;
				var navHeight = $('.header').height() + 10;

				var _ref = await this.footerIntersecting(),
				    isVisible = _ref.isVisible,
				    visibleHeight = _ref.visibleHeight;

				var subtractValue = isVisible ? visibleHeight + navHeight : navHeight;

				if (openNav.hasClass('history__years--active')) {
					openNav.css({
						marginTop: navHeight + "px",
						height: "calc(100% - " + subtractValue + "px)"
					});
				} else {
					openNav.removeAttr('style');
				}
			},
			footerIntersecting: function footerIntersecting() {
				var $footer = $('.footer');
				var $footerHegiht = $footer.outerHeight();

				return new Promise(function (resolve) {
					var isVisible = false;
					var visibleHeight = void 0;

					var observer = new IntersectionObserver(function (entries) {
						if (entries[0].isIntersecting) {
							visibleHeight = Math.round($footerHegiht * entries[0].intersectionRatio);
							isVisible = true;
						} else {
							isVisible = false;
							visibleHeight = 0;
						}
						resolve({ isVisible: isVisible, visibleHeight: visibleHeight });
					});

					observer.observe($footer[0]);
				});
			}
		};

		module.exports = history;
	}, {}], 8: [function (require, module, exports) {
		'use strict';

		var insights = {
			init: function init() {
				var $itemsContainer = $('#items-container'),
				    $filters = $('main > .insights__circles'),
				    $circles = $('.insights__circles'),
				    $insightsContainer = $('.insights-container'),
				    $headerHeight = $('.header').height(),
				    $navDistance = $('.insights__circles').offset().top - $headerHeight,
				    $windowDistance = $(window).scrollTop(),
				    $pageOffset = $('html').offset().top;
				if ($windowDistance > $pageOffset) {
					$circles.removeClass('insights__circles--active');
				}

				$itemsContainer.on('click', '.insights__info > button.btn', function () {
					var obj = {
						load: $itemsContainer.data('load') + 1,
						category: $filters.find('.insights__circle--active').length ? $filters.find('.insights__circle--active').parent().data('category-id') : -1
					};

					fetch($itemsContainer, obj);
				});

				$filters.find('.insights__circleWrap').on('click', function () {
					var $this = $(this);

					$this.siblings().find('span.insights__circle').removeClass('insights__circle--active');
					$this.siblings().find('span.insights__text').removeClass('insights__text--active');

					$this.find('span.insights__circle').toggleClass('insights__circle--active');
					$this.find('span.insights__text').toggleClass('insights__text--active');

					var obj = {
						load: 1,
						category: $this.find('span.insights__circle').hasClass('insights__circle--active') ? $this.data('category-id') : -1
					};

					fetch($itemsContainer, obj);
				});

				function updateUrl(obj) {
					delete obj.culture;
					history.replaceState({}, '', [location.protocol, '//', location.host, location.pathname].join('') + '?' + $.param(obj));
				}

				function fetch($wrapper, obj) {
					obj.culture = $itemsContainer.data('culture');

					$.post('/Umbraco/Surface/Listing/InsightsListing', obj, function (response) {
						if (response.length) {
							$wrapper.html(response);
							$wrapper.data('load', obj.load);
						}
						updateUrl(obj);
					}, 'html');
				}
			}
		};

		module.exports = insights;
	}, {}], 9: [function (require, module, exports) {
		'use strict';

		var navData = {
			init: function init() {
				var $tableWrapper = $('#js-nav-data-table');
				if ($tableWrapper.length === 0) return;

				var $loadMore = $('#js-load-more');
				if ($loadMore.length === 0) return;

				var itemsPerLoad = $tableWrapper.data('items-per-load');
				var controllerUrl = $tableWrapper.data('controller-url');
				var $tableBody = $tableWrapper.find('table tbody');
				var filter = [];

				$('[data-filter-item]').each(function () {
					filter.push($(this).data('filter-item'));
				});

				$loadMore.on('click', function () {
					var $this = $(this);
					var loadedRowsCount = $tableBody.children().length;

					$this.hide();
					$.ajax({
						url: controllerUrl,
						type: 'GET',
						dataType: 'html',
						data: { filter: filter, loadedItemsCount: loadedRowsCount, itemsPerLoad: itemsPerLoad },
						traditional: true
					}).done(function (response) {
						if (response === null || response === '') return;

						$tableBody.append(response);
						if ($tableBody.find('[last]').length === 0) $this.show();
					});
				});
			}
		};

		module.exports = navData;
	}, {}], 10: [function (require, module, exports) {
		'use strict';

		var people = {
			init: function init() {
				var personId = document.location.hash;
				if (personId.length) {
					$('.expandable-item-visible[data-popup="#item' + personId.replace('#', '') + '"]').find('a').click();
				}
			}
		};

		module.exports = people;
	}, {}], 11: [function (require, module, exports) {
		'use strict';

		var products = {
			init: function init() {
				this.syncProducts();
			},

			syncProducts: function syncProducts() {
				var productsPage = $('.main--products');
				if (productsPage !== undefined && productsPage.length) {
					var productsPageWrap = $('.wrap--products');
					var links = $('.products__link');
					var linksNum = $('.products__link').length;
					var productsLine = $('.line-animated--horizontal');
					var sections = $('.products__section');
					var nav = $('.products__top-wrap');
					var navItem = $('.products__top-wrap').find('li');

					var i = 0;
					var totalWidth = 0;
					var toLeft = 0;
					var offsetLeft = '';
					var pageOffset = productsPageWrap.offset().top - $('header').height();
					var paddingLeft = parseInt($('.products__progress-wrap').css('padding-left'));

					if (window.matchMedia('(max-width: 768px)').matches) {
						toLeft = parseInt($(navItem).eq(0).outerWidth()) / 2 - paddingLeft;
					} else {
						toLeft = parseInt($(navItem).eq(0).outerWidth()) / 2 - 8;
					}

					window.scrollTo(0, 0);

					navItem.each(function () {
						totalWidth += parseInt($(this).css('width'));
					});

					if (window.matchMedia('(max-width: 768px)').matches) {
						nav.find('.products__top-inner').css({
							'width': totalWidth + 'px'
						});
					}

					//animate line on load
					productsLine.animate({
						'width': toLeft + 'px'
					}, 800);
					links.eq(0).addClass('products__link--active');
					links.on('click', function () {
						if ($(this).parent().index() != 0) {
							offsetLeft = $(this).parent().index() * $(this).parent().outerWidth() - $(this).parent().outerWidth() / linksNum - paddingLeft * (linksNum / 2);
						} else {
							offsetLeft = 0;
						}
						$('html, body').animate({
							scrollTop: pageOffset + 'px'
						}, 800);
						if (window.matchMedia('screen and (min-width: 1025px)').matches) {
							toLeft = $(this).position().left;
							if ($(this).last()) {
								toLeft = $(this).position().left - 20;
							}
						} else if (window.matchMedia('(max-width: 960px)').matches && window.matchMedia('(min-width: 768px)').matches) {
							toLeft = $(this).position().left + $(this).width() / 2 - paddingLeft * 2;
						} else {
							toLeft = $(this).position().left + $(this).width() / 2 - 20;
						}
						productsLine.animate({
							'width': toLeft + 'px'
						}, 800);
						nav.animate({
							scrollLeft: offsetLeft
						}, 800);
						i = $(this).parent().index();
						links.not($(this).addClass('products__link--active')).removeClass('products__link--active');
						sections.not($(sections).eq(i).show()).hide();
					});
					//trigger click in certain link with location hash
					if (window.location.hash) {
						$('.products__link[href="' + window.location.hash + '"]').trigger('click');
					}
				}
			}
		};

		module.exports = products;
	}, {}], 12: [function (require, module, exports) {
		'use strict';

		var search_results = {
			init: function init() {

				var $container = $('.js-search-results');
				var $headerHeight = '';
				getSearchResultsForPage(1);

				function getSearchResultsForPage(currentPage) {
					var data = {
						page: currentPage
					};
					$.ajax({
						type: 'GET',
						url: '/umbraco/surface/listing/SearchResultsListing',
						data: data,
						cache: false,
						success: function success(response) {
							$container.children().remove();
							$container.append(response);
							initPagination();
							truncateText();
						}
					});
					$(document).ready(function () {
						addHrefValueOnSearchTerm();
					});
				}

				function initPagination() {
					$('.pagination-item').on('click', function () {
						$headerHeight = $('.header').height() + 50;
						getSearchResultsForPage($(this).text());
						$('html, body').animate({ scrollTop: $('.search-results').offset().top - $headerHeight }, 600);
					});

					$('.arrow-prev').on('click', function () {
						$headerHeight = $('.header').height() + 50;
						getSearchResultsForPage($(this).data('page'));
						$('html, body').animate({ scrollTop: $('.search-results').offset().top - $headerHeight }, 600);
					});

					$('.arrow-next').on('click', function () {
						$headerHeight = $('.header').height() + 50;
						getSearchResultsForPage($(this).data('page'));
						$('html, body').animate({ scrollTop: $('.search-results').offset().top - $headerHeight }, 600);
					});
				}

				function addHrefValueOnSearchTerm() {
					$('.search-result').each(function () {
						var $url = $(this).find('h2 a').attr('href');
						$(this).find('.search-term-url').attr('href', $url);
					});
				}

				function truncateText() {
					var _this = this;
					setTimeout(function () {
						var searchText = $('.search-result').find('h2 a');
						if (!searchText.length) return;
						var serachWidth = $('.js-search-results').width();
						$(searchText).each(function () {
							if ($(this).width() > serachWidth) {
								var parent = $(this).parent();
								var text = $(this).text();
								parent.addClass('truncate');
								createTooltip(parent, text);
							}
						});
					}, 200);
				}

				function createTooltip(item, text) {
					var tooltip = document.createElement('span');
					tooltip.className = 'tooltip';
					tooltip.innerHTML = text;
					$(item).append(tooltip);
				}
			}
		};

		module.exports = search_results;
	}, {}], 13: [function (require, module, exports) {
		'use strict';

		module.exports = {

			initSearch: function initSearch(tboxSelector, linkSelector) {
				var self = this;
				var $tboxSearch = $(tboxSelector),
				    $link = $(linkSelector);

				if ($tboxSearch.length > 0 && $link.length > 0) {
					$link.click(function (e) {
						e.preventDefault();
						var searchTerm = self.strip($tboxSearch.val()).trim(),
						    searchUrl = $('body').data('search-page-url');

						if (searchTerm !== '' && searchTerm !== $tboxSearch.attr('placeholder') && searchUrl != null) {
							window.location.href = searchUrl + (searchUrl.indexOf('?') > -1 ? "&q=" : "?q=") + escape(searchTerm);
						}

						return false;
					});

					$tboxSearch.keypress(function (event) {
						var $self = $(this),
						    searchTerm = $self.val().trim();

						if (event.keyCode === 13 && searchTerm !== '' && searchTerm !== $self.attr('placeholder')) {
							event.stopPropagation();
							$link.click();

							return false;
						} else if (event.keyCode === 13) {
							return false;
						}

						return true;
					});
				}
			},

			strip: function strip(html) {
				var tmp = document.createElement("DIV");
				tmp.innerHTML = html;
				return tmp.textContent || tmp.innerText || "";
			}
		};
	}, {}] }, {}, [1]);